import React, { useState } from "react";
import { Eye, EyeOff } from "lucide-react";

// Text input with a show/hide password toggle. Forwards all input props (value, onChange, etc.).
export function PasswordInput({ testId, toggleTestId, className = "input-soft", ...props }) {
  const [show, setShow] = useState(false);
  return (
    <div className="relative">
      <input
        data-testid={testId}
        type={show ? "text" : "password"}
        className={`${className} pr-11`}
        {...props}
      />
      <button
        type="button"
        data-testid={toggleTestId}
        onClick={() => setShow((s) => !s)}
        aria-label={show ? "Hide password" : "Show password"}
        className="absolute inset-y-0 right-0 flex items-center pr-3 text-[#8A9A86] hover:text-[#1E3F33]"
      >
        {show ? <EyeOff className="w-4 h-4" /> : <Eye className="w-4 h-4" />}
      </button>
    </div>
  );
}
